<div class="app-profile-menu__card bg-10 mb-8">
  @if (authService.loggedIn) {
    <div class="app-profile-menu__card__body">
      <span class="h4-m mb-2">{{ userFullName$ | async }}</span>
      <span class="c2-r t-not-capitalize c-50 mb-8">
        @let _userLogin = '@' + (userState.userLogin$ | async);

        <span [appClippedTextTooltip]="_userLogin">
          {{ _userLogin }}
        </span>
      </span>

      <div class="app-profile-menu__card-snack br-12">
        <span class="c2-r">
          {{ (userState.role$ | async)?.code | lowercase }}
        </span>
      </div>

      <div
        class="app-horizontal-divider --05"
        style="margin-bottom: 8px; width: calc(100% + 24px)"></div>

      <div class="c2-r c-50">
        <app-copy-icon [textToCopy]="settingsState.version || '-'">
          Site Version: {{ settingsState.version || '-' }}
        </app-copy-icon>
      </div>
    </div>
  }
</div>

<a
  class="app-profile-menu__item c-base"
  style="text-decoration-line: none"
  id="profile.personal"
  (click)="_onEditProfileClick()">
  <app-svg
    [icon]="'RealEstate24'"
    [disabledHover]="true"
    class="pr-8 c-50">
  </app-svg>

  <span class="b4-r">
    {{ 'pages.personalSettings.name' | translate }}
  </span>
</a>

<div class="app-horizontal-divider --05 mt-4 mb-4"></div>

@if (!userState.isClient && ([Authorities.SettingsView] | hasAuthorities)) {
  <a
    [routerLink]="['/system-settings']"
    class="app-profile-menu__item c-base"
    style="text-decoration-line: none"
    id="profile.system"
    (click)="_onSettingsClick()">
    <app-svg
      [icon]="'Settings_24'"
      [disabledHover]="true"
      class="pr-8 c-50">
    </app-svg>

    <span class="b4-r">
      {{ 'common.systemSettings' | translate }}
    </span>
  </a>
}

@if (authService.loggedIn && ([Authorities.BillingView] | hasAuthorities)) {
  <a
    [routerLink]="['/billing']"
    class="app-profile-menu__item c-base"
    style="text-decoration-line: none"
    id="profile.billing">
    <app-svg
      [icon]="'Card24'"
      [disabledHover]="true"
      class="pr-8 c-50">
    </app-svg>

    <span class="b4-r">
      {{ 'pages.billing.name' | translate }}
    </span>
  </a>
}

@if (
  !userState.isClient &&
  ([
    Authorities.CompaniesView,
    Authorities.LogotypeModify,
    Authorities.LogotypeDelete,
    Authorities.SiteInfoView,
    Authorities.SiteInfoModify,
  ] | hasAuthorities: 'one_of')
) {
  <a
    [routerLink]="['/company-profile']"
    class="app-profile-menu__item c-base"
    style="text-decoration-line: none"
    id="profile.company"
    (click)="_onCompanyClick()">
    <app-svg
      [icon]="'Entity2_24'"
      [disabledHover]="true"
      class="pr-8 c-50">
    </app-svg>

    <span class="b4-r">
      {{ 'pages.companySettings.name' | translate }}
    </span>
  </a>
}

@if (
  !userState.isClient &&
  ([
    Authorities.ManagersView,
    Authorities.RolesView,
    Authorities.ProfilesView,
    Authorities.SettingsView,
  ] | hasAuthorities: 'one_of')
) {
  <a
    [routerLink]="['/people-management']"
    class="app-profile-menu__item c-base"
    style="text-decoration-line: none"
    id="profile.people"
    (click)="_onPeopleSettingsClick()">
    <app-svg
      [icon]="'UserOutline_24'"
      [disabledHover]="true"
      class="pr-8 c-50">
    </app-svg>

    <span class="b4-r">
      {{ 'pages.peopleSettings.name' | translate }}
    </span>
  </a>

  <div class="app-horizontal-divider --05 mt-4 mb-4"></div>
}

@if (authService.loggedIn) {
  <div
    class="app-profile-menu__item app-profile-menu__item_danger"
    (click)="_onLogoutClick()">
    <app-svg
      [icon]="'Logout_24'"
      [subType]="'danger'"
      [disabledHover]="true"
      class="pr-8">
    </app-svg>

    <span class="b4-r c-danger">
      {{ 'common.logout' | translate }}
    </span>
  </div>
} @else {
  <div
    class="app-profile-menu__item"
    (click)="_onLoginClick()">
    <app-svg
      [icon]="'Login_24'"
      [disabledHover]="true"
      class="pr-8 c-50">
    </app-svg>

    <span class="b4-r">
      {{ 'common.login' | translate }}
    </span>
  </div>
}
